import type { MixpanelTracker } from '@issuu/tracking-micro';
import { initMixpanel, initMonitor } from '@issuu/tracking-micro';

import { HOST_PINGBACK_PUBLICNAME } from './config';
import type { MonitorData } from './global';

const EVENT_PREFIX = 'prodict-zendesk.chattag';

const mixpanelTracker = initMixpanel();

export const trackMixpanel: MixpanelTracker['track'] = (...args) => {
    mixpanelTracker.track(...args);
};

const monitorTracker = initMonitor({ pingbackHost: HOST_PINGBACK_PUBLICNAME });
export const monitor = (data: MonitorData) => {
    monitorTracker({ type: `${EVENT_PREFIX}.${data.action}`, ...data });
};

export default monitor;
